
  /**
   * @Author: sunchao
   * @Date:   2019/5/27 13:55
   */
  import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
  export default class Step extends Vue {
      @Prop() private active!: string;
  }
